const value = input => input || '-'
const date = input => input ? String(input).slice(0,10).split('-').reverse().join('/') : '-'

export const generateWarrantyCertificatePDF = (warranty, company = {}) => new Promise((resolve, reject) => {
  if (!window.pdfMake) return reject(new Error('PDF engine is not available'))
  window.pdfMake.fonts = {
    THSarabunNew: {
      normal: 'THSarabunNew.ttf', bold: 'THSarabunNew Bold.ttf',
      italics: 'THSarabunNew Italic.ttf', bolditalics: 'THSarabunNew BoldItalic.ttf'
    }
  }
  const doc = {
    pageSize: 'A4', pageMargins: [42,42,42,42], defaultStyle: {font:'THSarabunNew',fontSize:16},
    content: [
      {text:company.company_name||'ATOMSOFT ERP',fontSize:20,bold:true,alignment:'center'},
      {text:'ใบรับประกันสินค้า / WARRANTY CERTIFICATE',fontSize:24,bold:true,alignment:'center',margin:[0,8,0,18]},
      {table:{widths:['34%','66%'],body:[
        [{text:'เลขที่ใบรับประกัน',bold:true},value(warranty.warranty_number)],
        [{text:'สินค้า',bold:true},value(warranty.product_name)],
        [{text:'SKU',bold:true},value(warranty.barcode)],
        [{text:'Serial Number',bold:true},value(warranty.serial_number)],
        [{text:'ลูกค้า',bold:true},value(warranty.customer_name)],
        [{text:'เอกสารการขาย',bold:true},value(warranty.receipt_number||warranty.invoice_number)],
        [{text:'วันที่เริ่มรับประกัน',bold:true},date(warranty.warranty_start_date)],
        [{text:'ประกันร้านถึง',bold:true},date(warranty.shop_warranty_end_date)],
        [{text:'ประกันผู้ผลิตถึง',bold:true},date(warranty.manufacturer_warranty_end_date)]
      ]},layout:{fillColor:row=>row%2?'#f7f9fc':null,paddingLeft:()=>8,paddingRight:()=>8,paddingTop:()=>7,paddingBottom:()=>7}},
      {text:'เงื่อนไขการรับประกัน',bold:true,fontSize:18,margin:[0,20,0,6]},
      {text:value(warranty.terms_snapshot),margin:[0,0,0,42]},
      {columns:[{width:'45%',text:'ลงชื่อผู้รับสินค้า\n\n____________________________',alignment:'center'},
        {width:'10%',text:''},{width:'45%',text:'ลงชื่อผู้รับรอง\n\n____________________________',alignment:'center'}]}
    ],
    footer:(current,total)=>({text:`หน้า ${current}/${total}`,alignment:'right',margin:[0,0,42,0],fontSize:11})
  }
  window.pdfMake.createPdf(doc).getDataUrl(resolve)
})

export default generateWarrantyCertificatePDF
